import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import { Authentication, Paging, User } from '@/store/models';
import store from '@/store';
import jwtService from '@/services/common/jwt.service';
import authService from '@/services/common/auth.service';

@Module({ namespaced: true, name: 'auth', store, dynamic: true })
class AuthModule extends VuexModule {
  public authentication: Authentication | null = null;
  public error: Error | null = null;
  public user: User | null = null;
  public coaches: User[] | [] = [];
  public paging: Paging | null = null;

  @MutationAction
  async setAuthentication(authentication: Authentication) {
    return { authentication };
  }

  @MutationAction({ mutate: ['user', 'authentication'], rawError: true })
  async logout() {
    await jwtService.destroyJWT();
    return { user: null, authentication: null };
  }

  @MutationAction({ mutate: ['user'], rawError: true })
  async getAdminInfo() {
    const user = await authService.getAdminInfo();
    return { user: user };
  }
}

const authModule = getModule(AuthModule);
export default authModule;
